import {_} from 'lodash';
import {OverrideAbstractViewModel, template as tpl, TemplatePlaceholder, templateTooltip} from "./Abstract";
import {IStatus, IMoreStatus} from "./index";
import {nsOverride} from "./nsOverride";
import {ObjectTypeId} from "../../constants";

export let template = tpl.replace(TemplatePlaceholder, templateTooltip);

export class viewModel extends OverrideAbstractViewModel {

    protected getMoreStatus(): IMoreStatus {
        const o = this.override;
        const {isDeleted, isSynced} = this._getStatus();
        return nsOverride.getMoreStatus(isSynced, isDeleted, o.value, ObjectTypeId.System);
    }

}
